import { utcToZonedTime } from 'date-fns-tz';
import moment from 'moment';
import * as Yup from 'yup';

export const CHAR_LIMIT_MAP = {
    name: { min: 3, max: 80 },
    eventOrganiserName: { max: 50 },
    description: { min: 3, max: 150 },
    supportEmail: { min: 3, max: 254 },
};

const CreateAirmeetV2Schema = Yup.object().shape({
    name: Yup.string()
        .trim()
        .min(
            CHAR_LIMIT_MAP.name.min,
            `Minimum ${CHAR_LIMIT_MAP.name.min} characters required`
        ),
    isPrivate: Yup.boolean(),
    guestAuth: Yup.boolean(),
    initDate: Yup.date()
        .test({
            name: 'min-datetime',
            test: function (initDt) {
                const { timeZone, editMode } = this.options.context;
                const currentZonedTime = utcToZonedTime(new Date(), timeZone);
                if (initDt < currentZonedTime && !editMode) {
                    if (
                        initDt.toDateString() ===
                        currentZonedTime.toDateString()
                    ) {
                        return this.createError({
                            message: 'Cannot create event for past time',
                            path: 'initTime',
                        });
                    } else {
                        return this.createError({
                            message: 'Cannot create event for past date',
                            path: 'initDate',
                        });
                    }
                }
                return true;
            },
        })
        .max(
            moment().add({ years: 1 }),
            'Cannot enter date 1 year from current date'
        ),
    finalDate: Yup.date()
        .min(Yup.ref('initDate'), 'End Date cannot be earlier than start date')
        .max(
            moment(Yup.ref('initDate')).add({ years: 5 }),
            'Cannot enter a date 5 years from start date'
        ),
    timeZone: Yup.string().required('Time zone is required'),
    hasVirtualTables: Yup.boolean(),
    tableCount: Yup.number().when('hasVirtualTables', {
        is: true,
        then: Yup.number()
            .min(1, 'At least one table is required')
            .max(500, 'Max 500 tables allowed'),
    }),
    supportEmail: Yup.string()
        .trim()
        .lowercase()
        .email('Please provide a valid email address'),
});

const CreateAirmeetV2OnboardingSchema = Yup.object().shape({
    eventOrganiserName: Yup.string()
        .trim()
        .required(`Event organizer's name is required`),
});

export const validateFormData = async (data, options, setErrors) => {
    try {
        await CreateAirmeetV2Schema.validate(data, options);
        setErrors({});
        return true;
    } catch (error) {
        let errorData = [];
        (error.inner || []).map((inr) => {
            if (!errorData[inr.path]) {
                errorData[inr.path] = inr.message;
            }
            return inr;
        });
        setErrors(errorData);
        return false;
    }
};

export const validateSingleField = async (
    name,
    value,
    setErrors,
    isOnboardingFieldCheck = false
) => {
    try {
        if (isOnboardingFieldCheck)
            await Yup.reach(CreateAirmeetV2OnboardingSchema, name).validate(
                value.trim()
            );
        else
            await Yup.reach(CreateAirmeetV2Schema, name).validate(value.trim());
        setErrors((errors) => ({ ...errors, [name]: '' }));
        return true;
    } catch (error) {
        setErrors((errors) => ({ ...errors, [name]: error.message }));
        return false;
    }
};
